import { TXTWCL_Special_characters_are_not_all_ELL } from '../translations';
import type { Error } from '../types';
import { CONTAIN_LATIN_CHARACTERS_ONLY } from '../utils/regex';

export const mustContainOnlyLatinCharacters =
  () =>
  (value: string): Error => ({
    valid: !CONTAIN_LATIN_CHARACTERS_ONLY.test(value),
    message: TXTWCL_Special_characters_are_not_all_ELL
  });
